/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommmonService } from 'src/app/utils/common.service';
import { ConsultaSolicitudService } from 'src/app/home/services/consulta-solicitud.service';
import { BENEFICIO_ID, ESTADO_SOLICITUD } from 'src/app/workflow/benefit-application/utils/constants/constats';
import { EmployeesapService } from 'src/app/home/services/employeesap.service';
import { SolicitudVacacionesService } from 'src/app/home/services/solicitud-vacaciones.service';
import { GestionHumanaService } from 'src/app/home/services/gestion-humana.service';
import { ValidatorPrestamoService } from 'src/app/home/services/validator-prestamo.service';

@Component({
  selector: 'app-benefit-header',
  templateUrl: './benefit-header.component.html',
  styleUrls: ['./benefit-header.component.scss'],
})
export class BenefitHeaderComponent implements OnInit {
  @Input() datorating!: number;
  public showHyperLink = false;
  public title = '';
  public description = '';
  public mira = true;
  public baseBenefit = '';
  public baseAntiquity = '';
  public category = '';
  public antiquity!:number;
  public plan!:any;
  public beneficiaryType = '';
  public link = '';
  public longDescription = '';
  public image = '';
  public icon = '';
  public id = 0;
  public isCopec = false;
  public vigencia = false; // Controla si el beneficio está habilitado
  totalVotes: any;
  average: any;
  planId = '';
  url = '';
  isValid = false;
  private urlPattern = /^(https?:\/\/[^\s/$.?#].[^\s]*)$/i;
  user_plan!:any;

  private readonly BENEFICIOS_CON_PRECARGA: number[] = [
    BENEFICIO_ID.AYUDA_ESPECIAL_TRABAJADOR,
    BENEFICIO_ID.FONDO_DEPORTISTA_SELECCIONADO,
    BENEFICIO_ID.FONDO_LIBRE_DISPOSICION,
    BENEFICIO_ID.REEMBOLSO_ANTICONCEPTIVO,
    BENEFICIO_ID.REEMBOLSO_PROCEDIMIENTO_ANTICONCEPTIVO,
  ];
  
  // Propiedades para modal de alerta de cuotas
  modalAlertaCuotas = false;
  mensajeAlertaCuotas = '';
  tituloAlertaCuotas = '';
  permitirContinuar = true; // Controla si puede avanzar al formulario
  
  // Propiedades para modal de solicitudes en proceso
  modalSolicitudesEnProceso = false;
  mensajeSolicitudesEnProceso = '';
  tituloSolicitudesEnProceso = '';
  nombreColaborador = '';
  solicitudesEnProcesoIds: { solicitud_id: number; beneficiarios: string[] }[] = [];
  cargando_spinner: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private commonService: CommmonService,
    private router: Router,
    private consultaSolicitudService: ConsultaSolicitudService,
    private employeeSapService: EmployeesapService,
    private solicitudVacacionesService: SolicitudVacacionesService,
    private gestionHumanaService: GestionHumanaService,
    private validatorPrestamoService: ValidatorPrestamoService,
  ) {}

  async ngOnInit() {
    window.scrollTo(0, 0);
    this.user_plan = this.activatedRoute.snapshot.data['resolve_user_plan'] ?? []; 

    const categories = JSON.parse(
      this.commonService.getItemLocalStorage('categories') ?? '[]',
    );
    const beneficiaryTypes = JSON.parse(
      this.commonService.getItemLocalStorage('beneficiaryTypes') ?? '[]',
    );
    const planes = JSON.parse(
      this.commonService.getItemLocalStorage('plans') ?? '[]',
    );

    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.mapBenefitToComponent(params, categories, beneficiaryTypes, planes);
      const benefit = this.getBenefit(params);
      if (benefit && this.BENEFICIOS_CON_PRECARGA.includes(benefit.id)) {
        this.ejecutarPrecargaSolicitudes(benefit.id);
      }
    });

  }

  private ejecutarPrecargaSolicitudes(beneficioId: number): void {
    void this.cargarSolicitudesBeneficio(beneficioId);
  }

  private async cargarSolicitudesBeneficio(beneficioId: number): Promise<void> {
    try {
      const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
      const rut = employeeSap?.colaborador?.rut;
      if (!rut) return;
      await this.consultaSolicitudService.precargarSolicitudesBeneficio(beneficioId, rut);
    } catch (error) {
      console.error('Error al precargar solicitudes del beneficio:', beneficioId, error);
    }
  }


      @HostListener('window:scroll', [])
    onscroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > 200) { 
      this.mira = false; 
    } else {
      this.mira = true;
    } 
}
   
   imagenPlan(planes:any, benefit:any){
    const idImage = planes.find((p:any)=>p.id === benefit.plans[0]);
    return idImage ? idImage : planes.find((p:any)=>p.id === 1)
   }

  async goToRedirect() {
    this.cargando_spinner=true;
    // Validar que el beneficio est\u00e9 habilitado (vigencia = true)
    if (this.vigencia) {
      console.log('Beneficio deshabilitado, no se puede acceder');
      return;
    }

    // Convertir el ID a n\u00famero para comparaci\u00f3n
    const beneficioId = typeof this.id === 'string' ? parseInt(this.id) : this.id;
    
    // Si es el beneficio de Incorporación Beneficiario (Seguro Complementario), verificar solicitudes en proceso
    if (beneficioId === BENEFICIO_ID.INCORPORACION_BENEFICIARIO) {
      await this.verificarSolicitudesIncorporacionBeneficiario();
      return;
    }
    
    // Si es el beneficio de Préstamo Viaje, verificar solicitudes previas
    if (beneficioId === BENEFICIO_ID.PRESTAMO_VIAJE) {
      await this.verificarSolicitudesPrestamoViaje();
      return;
    }

    // Si es el beneficio de Recepción de Vivienda, verificar solicitudes previas
    if (beneficioId === BENEFICIO_ID.RECEPCION_VIVIENDA) {
      await this.verificarSolicitudesRecepcionVivienda();
      return;
    }

    // Si es el beneficio de Préstamo Bienestar, verificar solicitudes previas
    if (beneficioId === BENEFICIO_ID.PRESTAMO_BIENESTAR) {
      await this.verificarSolicitudesPrestamoBienestar();
      return;
    }

    // Si es el beneficio de Préstamo Compra de Vivienda, verificar solicitudes previas
    if (beneficioId === BENEFICIO_ID.PRESTAMO_COMPRA_VIVIENDA) {
      await this.verificarSolicitudesPrestamoCompraVivienda();
      return;
    }

    // Si es el beneficio de Préstamo Reparación de Vivienda, verificar solicitudes previas
    if (beneficioId === BENEFICIO_ID.PRESTAMO_REPARACION_VIVIENDA) {
      await this.verificarSolicitudesPrestamoReparacionVivienda();
      return;
    }

    // Si es el beneficio de Préstamo Libre Disposición, verificar solicitudes previas
    if (beneficioId === BENEFICIO_ID.PRESTAMO_LIBRE_DISPOSICION) {
      const requisitos= await this.validacionRequisitosPrestamoLibreDisposicion();
      if(requisitos){
        await this.verificarCuotasEnSolicitudesPrestamoLibreDisposicion();
      return;
      }
      return;
    }

    // Validación especial para Programa de Vacunación
    if (beneficioId === BENEFICIO_ID.PROGRAMA_VACUNACION) {
      await this.verificarSolicitudesProgramaVacunacion();
      return;
    }

    // Si es el beneficio de Examenes Preventivos mayores de 40, verificar edad
    if (beneficioId === BENEFICIO_ID.EXAMENES_PREVENTIVOS_MAYORES) {
      await this.verificarEdadExamenPreventivo();
      return;
    }

    // Validación especial para Bono Vacaciones
    if (beneficioId === BENEFICIO_ID.BONO_VACACIONES) {
      await this.verificarBonosVacaciones();
      return;
    }

    // Flujo normal para otros beneficios
    this.navegarAFormulario();
  }

  async verificarSolicitudesPrestamoViaje() {
    try {
      // Obtener datos del colaborador
      const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
      
      if (!employeeSap || !employeeSap.colaborador || !employeeSap.colaborador.rut) {
        console.error('No se pudo obtener el RUT del colaborador');
        this.navegarAFormulario();
        return;
      }

      const rut = employeeSap.colaborador.rut;

      // PRIMERA VALIDACIÓN: Verificar si hay solicitud PENDIENTE (en curso)
      const respuestaPendiente = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.PRESTAMO_VIAJE,
        rut,
        ESTADO_SOLICITUD.PENDIENTE
      );

      // Si existe solicitud pendiente, mostrar modal y NO continuar
      if (respuestaPendiente && respuestaPendiente.existe && respuestaPendiente.total > 0) {
        this.tituloAlertaCuotas = 'Préstamo en Curso';
        this.mensajeAlertaCuotas = 'Tu solicitud de préstamo está siendo revisada por el administrador. No es posible iniciar otra solicitud hasta que recibas una respuesta sobre la actual.';
        this.permitirContinuar = false;
        this.modalAlertaCuotas = true;
        this.cargando_spinner = false;
        return;
      }

      // SEGUNDA VALIDACIÓN: Consultar solicitudes APROBADAS
      const respuestaAprobada = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.PRESTAMO_VIAJE,
        rut,
        ESTADO_SOLICITUD.APROBADA
      );

      // Si no existe solicitud aprobada, continuar normalmente
      if (!respuestaAprobada || !respuestaAprobada.existe || respuestaAprobada.total === 0) {
        this.navegarAFormulario();
        return;
      }

      // Procesar la primera solicitud encontrada
      const solicitud = respuestaAprobada.solicitudes[0];
      const numeroCuotas = solicitud.formulario?.informacion_adicional?.Numero_de_cuotas?.valor || 0;
      const fechaActualizacion = solicitud.fecha_actualizacion;

      // Si no hay cuotas registradas (0 o null), continuar normalmente
      if (!numeroCuotas || numeroCuotas === 0) {
        this.navegarAFormulario();
        return;
      }

      // Calcular meses transcurridos
      const mesesTranscurridos = this.calcularMesesTranscurridos(fechaActualizacion);

      // Si los meses transcurridos son >= cuotas, no mostrar mensaje y continuar
      if (mesesTranscurridos >= numeroCuotas) {
        this.navegarAFormulario();
        return;
      }

      // Mostrar modal con la información
      this.mostrarModalCuotas(numeroCuotas, mesesTranscurridos);

    } catch (error) {
      console.error('Error al verificar solicitudes previas:', error);
      // En caso de error, continuar normalmente
      this.navegarAFormulario();
    }
  }

  async verificarSolicitudesRecepcionVivienda() {
    try {
      // Obtener datos del colaborador
      const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
      
      if (!employeeSap || !employeeSap.colaborador || !employeeSap.colaborador.rut) {
        console.error('No se pudo obtener el RUT del colaborador');
        this.navegarAFormulario();
        return;
      }

      const rut = employeeSap.colaborador.rut;

      // PRIMERA VALIDACIÓN: Verificar si hay solicitud PENDIENTE (en curso)
      const respuestaPendiente = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.RECEPCION_VIVIENDA,
        rut,
        ESTADO_SOLICITUD.PENDIENTE
      );

      // Si existe solicitud pendiente, mostrar modal y NO continuar
      if (respuestaPendiente && respuestaPendiente.existe && respuestaPendiente.total > 0) {
        this.tituloAlertaCuotas = 'Solicitud en Curso';
        this.mensajeAlertaCuotas = 'Ya tienes una solicitud de Ayuda Recepción de Vivienda en curso. No puedes solicitar otra hasta que se resuelva tu solicitud actual.';
        this.permitirContinuar = false;
        this.modalAlertaCuotas = true;
        this.cargando_spinner = false;
        return;
      }

      // SEGUNDA VALIDACIÓN: Verificar si ya tiene una solicitud APROBADA
      // Este beneficio solo se puede solicitar UNA VEZ
      const respuestaAprobada = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.RECEPCION_VIVIENDA,
        rut,
        ESTADO_SOLICITUD.APROBADA
      );

      // Si existe solicitud aprobada, mostrar modal y NO continuar
      if (respuestaAprobada && respuestaAprobada.existe && respuestaAprobada.total > 0) {
        this.tituloAlertaCuotas = 'Beneficio Ya Utilizado';
        this.mensajeAlertaCuotas = 'Ya has utilizado el beneficio de Ayuda Recepción de Vivienda. Este beneficio solo se puede solicitar una vez.';
        this.permitirContinuar = false;
        this.modalAlertaCuotas = true;
        this.cargando_spinner = false;
        return;
      }

      // Si no hay solicitudes previas, permitir continuar
      this.navegarAFormulario();

    } catch (error) {
      console.error('Error al verificar solicitudes de Recepción de Vivienda:', error);
      // En caso de error, continuar normalmente
      this.navegarAFormulario();
    }
  }

    async verificarSolicitudesPrestamoBienestar() {
    try {
      // Obtener datos del colaborador
      const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
      
      if (!employeeSap || !employeeSap.colaborador || !employeeSap.colaborador.rut) {
        console.error('No se pudo obtener el RUT del colaborador');
        this.navegarAFormulario();
        return;
      }

      const rut = employeeSap.colaborador.rut;

      // PRIMERA VALIDACIÓN: Verificar si hay solicitud PENDIENTE (en curso)
      const respuestaPendiente = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.PRESTAMO_BIENESTAR,
        rut,
        ESTADO_SOLICITUD.PENDIENTE
      );

      // Si existe solicitud pendiente, mostrar modal y NO continuar
      if (respuestaPendiente && respuestaPendiente.existe && respuestaPendiente.total > 0) {
        this.tituloAlertaCuotas = 'Préstamo en Curso';
        this.mensajeAlertaCuotas = 'Tu solicitud de préstamo está siendo revisada por el administrador. No es posible iniciar otra solicitud hasta que recibas una respuesta sobre la actual.';
        this.permitirContinuar = false;
        this.modalAlertaCuotas = true;
        this.cargando_spinner = false;
        return;
      }

      // SEGUNDA VALIDACIÓN: Consultar solicitudes APROBADAS
      const respuestaAprobada = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.PRESTAMO_BIENESTAR,
        rut,
        ESTADO_SOLICITUD.APROBADA
      );

      // Si no existe solicitud aprobada, continuar normalmente
      if (!respuestaAprobada || !respuestaAprobada.existe || respuestaAprobada.total === 0) {
        this.navegarAFormulario();
        return;
      }

      // Procesar la primera solicitud encontrada
      const solicitud = respuestaAprobada.solicitudes[0];
      const infoAdicional = solicitud.formulario?.informacion_adicional;
      
      // Buscar el campo de cuotas con diferentes variantes posibles
      const numeroCuotas = infoAdicional?.Cantidad_de_Cuotas?.valor || 
                          infoAdicional?.['Cantidad de Cuotas']?.valor ||
                          infoAdicional?.['Cantidad Cuotas']?.valor ||
                          infoAdicional?.Numero_de_cuotas?.valor ||
                          infoAdicional?.numeroCuotas?.valor || 0;
      const fechaActualizacion = solicitud.fecha_actualizacion;

      // Si no hay cuotas registradas (0 o null), continuar normalmente
      if (!numeroCuotas || numeroCuotas === 0) {
        this.navegarAFormulario();
        return;
      }

      // Calcular meses transcurridos
      const mesesTranscurridos = this.calcularMesesTranscurridos(fechaActualizacion);

      // Si los meses transcurridos son >= cuotas, no mostrar mensaje y continuar
      if (mesesTranscurridos >= numeroCuotas) {
        this.navegarAFormulario();
        return;
      }

      // Mostrar modal con la información
      this.mostrarModalCuotas(numeroCuotas, mesesTranscurridos);

    } catch (error) {
      console.error('Error al verificar solicitudes previas:', error);
      // En caso de error, continuar normalmente
      this.navegarAFormulario();
    }
  }

  async verificarSolicitudesPrestamoCompraVivienda() {
    try {
      // Obtener datos del colaborador
      const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
      
      if (!employeeSap || !employeeSap.colaborador || !employeeSap.colaborador.rut) {
        console.error('No se pudo obtener el RUT del colaborador');
        this.navegarAFormulario();
        return;
      }

      const rut = employeeSap.colaborador.rut;

      // PRIMERA VALIDACIÓN: Verificar si hay solicitud PENDIENTE (en curso)
      const respuestaPendiente = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.PRESTAMO_COMPRA_VIVIENDA,
        rut,
        ESTADO_SOLICITUD.PENDIENTE
      );

      // Si existe solicitud pendiente, mostrar modal y NO continuar
      if (respuestaPendiente && respuestaPendiente.existe && respuestaPendiente.total > 0) {
        this.tituloAlertaCuotas = 'Préstamo en Curso';
        this.mensajeAlertaCuotas = 'Tu solicitud de préstamo está siendo revisada por el administrador. No es posible iniciar otra solicitud hasta que recibas una respuesta sobre la actual.';
        this.permitirContinuar = false;
        this.modalAlertaCuotas = true;
        this.cargando_spinner = false;
        return;
      }

      // SEGUNDA VALIDACIÓN: Consultar solicitudes APROBADAS
      const respuestaAprobada = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.PRESTAMO_COMPRA_VIVIENDA,
        rut,
        ESTADO_SOLICITUD.APROBADA
      );

      // Si no existe solicitud aprobada, continuar normalmente
      if (!respuestaAprobada || !respuestaAprobada.existe || respuestaAprobada.total === 0) {
        this.navegarAFormulario();
        return;
      }

      // Procesar la primera solicitud encontrada
      const solicitud = respuestaAprobada.solicitudes[0];
      const infoAdicional = solicitud.formulario?.informacion_adicional;
      
      const numeroCuotas = infoAdicional?.Cantidad_de_Cuotas?.valor || 
                          infoAdicional?.['Cantidad de Cuotas']?.valor ||
                          infoAdicional?.['Cantidad Cuotas']?.valor ||
                          infoAdicional?.Numero_de_cuotas?.valor ||
                          infoAdicional?.numeroCuotas?.valor || 0;
      const fechaActualizacion = solicitud.fecha_actualizacion;

      // Si no hay cuotas registradas (0 o null), continuar normalmente
      if (!numeroCuotas || numeroCuotas === 0) {
        this.navegarAFormulario();
        return;
      }

      // Calcular meses transcurridos
      const mesesTranscurridos = this.calcularMesesTranscurridos(fechaActualizacion);

      // Si los meses transcurridos son >= cuotas, no mostrar mensaje y continuar
      if (mesesTranscurridos >= numeroCuotas) {
        this.navegarAFormulario();
        return;
      }

      // Mostrar modal con la información
      this.mostrarModalCuotas(numeroCuotas, mesesTranscurridos);

    } catch (error) {
      console.error('Error al verificar solicitudes previas:', error);
      // En caso de error, continuar normalmente
      this.navegarAFormulario();
    }
  }

  async verificarSolicitudesPrestamoReparacionVivienda() {
    try {
      // Obtener datos del colaborador
      const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
      
      if (!employeeSap || !employeeSap.colaborador || !employeeSap.colaborador.rut) {
        console.error('No se pudo obtener el RUT del colaborador');
        this.navegarAFormulario();
        return;
      }

      const rut = employeeSap.colaborador.rut;

      // PRIMERA VALIDACIÓN: Verificar si hay solicitud PENDIENTE (en curso)
      const respuestaPendiente = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.PRESTAMO_REPARACION_VIVIENDA,
        rut,
        ESTADO_SOLICITUD.PENDIENTE
      );

      // Si existe solicitud pendiente, mostrar modal y NO continuar
      if (respuestaPendiente && respuestaPendiente.existe && respuestaPendiente.total > 0) {
        this.tituloAlertaCuotas = 'Préstamo en Curso';
        this.mensajeAlertaCuotas = 'Tu solicitud de préstamo está siendo revisada por el administrador. No es posible iniciar otra solicitud hasta que recibas una respuesta sobre la actual.';
        this.permitirContinuar = false;
        this.modalAlertaCuotas = true;
        this.cargando_spinner = false;
        return;
      }

      // SEGUNDA VALIDACIÓN: Consultar solicitudes APROBADAS
      const respuestaAprobada = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.PRESTAMO_REPARACION_VIVIENDA,
        rut,
        ESTADO_SOLICITUD.APROBADA
      );

      // Si no existe solicitud aprobada, continuar normalmente
      if (!respuestaAprobada || !respuestaAprobada.existe || respuestaAprobada.total === 0) {
        this.navegarAFormulario();
        return;
      }

      // Procesar la primera solicitud encontrada
      const solicitud = respuestaAprobada.solicitudes[0];
      const infoAdicional = solicitud.formulario?.informacion_adicional;
      
      const numeroCuotas = infoAdicional?.['Cantidad Cuotas']?.valor || 
                          infoAdicional?.Cantidad_Cuotas?.valor || 
                          infoAdicional?.Cantidad_de_Cuotas?.valor || 0;
      const fechaActualizacion = solicitud.fecha_actualizacion;

      // Si no hay cuotas registradas (0 o null), continuar normalmente
      if (!numeroCuotas || numeroCuotas === 0) {
        this.navegarAFormulario();
        return;
      }

      // Calcular meses transcurridos
      const mesesTranscurridos = this.calcularMesesTranscurridos(fechaActualizacion);

      // Si los meses transcurridos son >= cuotas, no mostrar mensaje y continuar
      if (mesesTranscurridos >= numeroCuotas) {
        this.navegarAFormulario();
        return;
      }

      // Mostrar modal con la información
      this.mostrarModalCuotas(numeroCuotas, mesesTranscurridos);

    } catch (error) {
      console.error('Error al verificar solicitudes previas:', error);
      // En caso de error, continuar normalmente
      this.navegarAFormulario();
    }
  }

  async verificarCuotasEnSolicitudesPrestamoLibreDisposicion() {
    try {
      // Obtener datos del colaborador
      const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
      
      if (!employeeSap || !employeeSap.colaborador || !employeeSap.colaborador.rut) {
        console.error('No se pudo obtener el RUT del colaborador');
        this.navegarAFormulario();
        return;
      }

      const rut = employeeSap.colaborador.rut;

      // PRIMERA VALIDACIÓN: Verificar si hay solicitud PENDIENTE (en curso)
      const respuestaPendiente = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.PRESTAMO_LIBRE_DISPOSICION,
        rut,
        ESTADO_SOLICITUD.PENDIENTE
      );

      // Si existe solicitud pendiente, mostrar modal y NO continuar
      if (respuestaPendiente && respuestaPendiente.existe && respuestaPendiente.total > 0) {
        this.tituloAlertaCuotas = 'Préstamo en Curso';
        this.mensajeAlertaCuotas = 'Tu solicitud de préstamo está siendo revisada por el administrador. No es posible iniciar otra solicitud hasta que recibas una respuesta sobre la actual.';
        this.permitirContinuar = false;
        this.modalAlertaCuotas = true;
        this.cargando_spinner = false;
        return;
      }

     // SEGUNDA VALIDACIÓN: Consultar solicitudes APROBADAS
      const respuestaAprobada = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.PRESTAMO_LIBRE_DISPOSICION,
        rut,
        ESTADO_SOLICITUD.APROBADA
      );

      // Si no existe solicitud aprobada, continuar normalmente
      if (!respuestaAprobada || !respuestaAprobada.existe || respuestaAprobada.total === 0) {
        this.navegarAFormulario();
        return;
      }

      // Procesar la primera solicitud encontrada
      const solicitud = respuestaAprobada.solicitudes[0];
      const infoAdicional = solicitud.formulario?.informacion_adicional;
      
      const numeroCuotas = infoAdicional?.Cantidad_de_Cuotas?.valor || 
                          infoAdicional?.['Cantidad de Cuotas']?.valor ||
                          infoAdicional?.['Cantidad Cuotas']?.valor ||
                          infoAdicional?.Numero_de_cuotas?.valor ||
                          infoAdicional?.numeroCuotas?.valor || 0;
      const fechaActualizacion = solicitud.fecha_actualizacion;

      // Si no hay cuotas registradas (0 o null), continuar normalmente
      if (!numeroCuotas || numeroCuotas === 0) {
        this.navegarAFormulario();
        return;
      }

      // Calcular meses transcurridos
      const mesesTranscurridos = this.calcularMesesTranscurridos(fechaActualizacion);

      // Si los meses transcurridos son >= cuotas, no mostrar mensaje y continuar
      if (mesesTranscurridos >= numeroCuotas) {
        this.navegarAFormulario();
        return;
      }

       // Mostrar modal con la información
      this.mostrarModalCuotas(numeroCuotas, mesesTranscurridos);


    } catch (error) {
      console.error('Error al verificar solicitudes previas:', error);
      // En caso de error, continuar normalmente
      this.navegarAFormulario();
    }
  }
  
  async validacionRequisitosPrestamoLibreDisposicion(){    
      try {
        const respValidator = await this.validatorPrestamoService.validarPrestamo('FRM_PRESTAMO_LIBRE_DISPOSICION');
        if (respValidator?.es_valida) {
          return true;
        }else{
            this.mostrarAlerta('No aplicas para este beneficio', 'Para postular a este beneficio debes cumplir con estos requisitos: Tener más de 1 año de antigüedad y contrato indefinido en Copec al 31 de diciembre de 2024.');
            return false;
        }
      } catch (e) {
        console.error('Error al validar requisitos del préstamo (backend validator):', e);
        this.mostrarAlerta('Hubo un error', 'Hubo un error en la validación de requisitos intentalo más tarde');
        return;
      }
  }





    async verificarSolicitudesProgramaVacunacion() {
      try {
        // Obtener datos del colaborador (solo validación de existencia)
        const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
        if (!employeeSap || !employeeSap.colaborador || !employeeSap.colaborador.rut) {
          console.error('No se pudo obtener el RUT del colaborador');
          this.navegarAFormulario();
          return;
        }
        const rut = employeeSap.colaborador.rut;
        const anioActual = new Date().getFullYear();

        // Helper: determina si la respuesta tiene alguna solicitud en el año actual
        const tieneSolicitudEnAnio = (respuesta: any): boolean => {
          if (!respuesta || !respuesta.existe || respuesta.total === 0) return false;
          const solicitudes = respuesta.solicitudes || [];
          return solicitudes.some((s: any) => {
            const f = s?.fecha_actualizacion;
            if (!f) return false;
            return new Date(f).getFullYear() === anioActual;
          });
        };

        // Consultar PENDIENTES y APROBADAS en paralelo para simplificar la lógica
        const [respuestaPendiente, respuestaAprobada] = await Promise.all([
          this.consultaSolicitudService.consultarSolicitudPorBeneficio(
            BENEFICIO_ID.PROGRAMA_VACUNACION,
            rut,
            ESTADO_SOLICITUD.PENDIENTE
          ),
          this.consultaSolicitudService.consultarSolicitudPorBeneficio(
            BENEFICIO_ID.PROGRAMA_VACUNACION,
            rut,
            ESTADO_SOLICITUD.APROBADA
          )
        ]);

        if (tieneSolicitudEnAnio(respuestaPendiente)) {
          this.tituloAlertaCuotas = 'Solicitud Pendiente';
          this.mensajeAlertaCuotas = 'Tienes una solicitud pendiente de aprobar para este beneficio.';
          this.permitirContinuar = false;
          this.modalAlertaCuotas = true;
          this.cargando_spinner = false;
          return;
        }

        if (tieneSolicitudEnAnio(respuestaAprobada)) {
          this.tituloAlertaCuotas = 'Solicitud Aprobada';
          this.mensajeAlertaCuotas = 'Ya tienes una solicitud aprobada para este beneficio durante este periodo.';
          this.permitirContinuar = false;
          this.modalAlertaCuotas = true;
          this.cargando_spinner = false;
          return;
        }

        // Si no hay pendientes ni aprobadas en el año actual, permitir continuar
        this.navegarAFormulario();
        return;

      } catch (error) {
        console.error('Error al verificar solicitudes previas de Programa de Vacunación:', error);
        // En caso de error, continuar normalmente
        this.navegarAFormulario();
        return;
      }
  }

  async verificarEdadExamenPreventivo() {
    try {
      const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
      if (!employeeSap || !employeeSap.colaborador) {
        console.error('No se pudo obtener datos del colaborador');
        // En caso de no poder obtener datos, permitir navegación por defecto
        this.navegarAFormulario();
        return;
      }

      const fechaNacimiento = employeeSap.colaborador.fechaNacimiento;
      // fechaNacimiento esperado en formato "YYYYMMDD"
      if (!fechaNacimiento || typeof fechaNacimiento !== 'string' || fechaNacimiento.length < 8) {
        console.error('Fecha de nacimiento inválida:', fechaNacimiento);
        this.navegarAFormulario();
        return;
      }

      const year = parseInt(fechaNacimiento.substring(0, 4), 10);
      const month = parseInt(fechaNacimiento.substring(4, 6), 10) - 1; // meses 0-11
      const day = parseInt(fechaNacimiento.substring(6, 8), 10);
      const nacimiento = new Date(year, month, day);
      const hoy = new Date();
      let edad = hoy.getFullYear() - nacimiento.getFullYear();
      const m = hoy.getMonth() - nacimiento.getMonth();
      if (m < 0 || (m === 0 && hoy.getDate() < nacimiento.getDate())) {
        edad--;
      }

      // Validación: debe ser mayor o igual a 40 años
      if (edad >= 40) {
        this.navegarAFormulario();
        return;
      } else {
        this.tituloAlertaCuotas = 'Requisito de Edad';
        this.mensajeAlertaCuotas = 'Este beneficio está disponible solo para personas mayores de 40 años. No puedes acceder al formulario.';
        this.permitirContinuar = false;
        this.modalAlertaCuotas = true;
        this.cargando_spinner = false;
        return;
      }
    } catch (error) {
      console.error('Error al verificar edad:', error);
      // En caso de error, continuar normalmente
      this.navegarAFormulario();
    }
  }

  calcularMesesTranscurridos(fechaActualizacion: string): number {
    const fechaActual = new Date();
    const fechaUpdate = new Date(fechaActualizacion);
    
    const yearsDiff = fechaActual.getFullYear() - fechaUpdate.getFullYear();
    const monthsDiff = fechaActual.getMonth() - fechaUpdate.getMonth();
    
    return yearsDiff * 12 + monthsDiff;
  }

  mostrarModalCuotas(numeroCuotas: number, mesesTranscurridos: number) {
    // Determinar si puede continuar (meses >= cuotas)
    this.permitirContinuar = mesesTranscurridos >= numeroCuotas;
    
    this.tituloAlertaCuotas = 'Información de Préstamo Anterior';
    
    if (this.permitirContinuar) {
      // Mensaje cuando SÍ puede continuar
      this.mensajeAlertaCuotas = `Tienes una solicitud aprobada previa con ${numeroCuotas} cuota${numeroCuotas > 1 ? 's' : ''}. Han transcurrido ${mesesTranscurridos} mes${mesesTranscurridos !== 1 ? 'es' : ''} desde la última actualización. Puedes solicitar un nuevo préstamo.`;
    } else {
      // Mensaje cuando NO puede continuar
      const cuotasFaltantes = numeroCuotas - mesesTranscurridos;
      this.mensajeAlertaCuotas = `Tienes una solicitud aprobada previa con ${numeroCuotas} cuota${numeroCuotas > 1 ? 's' : ''}. Han transcurrido ${mesesTranscurridos} mes${mesesTranscurridos !== 1 ? 'es' : ''} desde la última actualización. Debes esperar ${cuotasFaltantes} mes${cuotasFaltantes !== 1 ? 'es' : ''} más para solicitar un nuevo préstamo.`;
    }
    
    this.modalAlertaCuotas = true;
    this.cargando_spinner = false;
  }

  closeModalAlertaCuotas(event: boolean) {
    this.modalAlertaCuotas = event;
    
    // Solo continuar con la navegación si está permitido
    if (this.permitirContinuar) {
      this.navegarAFormulario();
    }
    // Si no está permitido, simplemente cierra el modal y se queda en la misma página
  }

  navegarAFormulario() {
    let query_params = {};
    const data = {
      title: this.title,
      id_benefit: this.id,
    };

    this.isValid = this.urlPattern.test(this.link);
    query_params = { data_notification: JSON.stringify(data) };
    if(this.id === 86) query_params = { data_notification: JSON.stringify(data), type_form: 'add_other_beneficiary' };

    this.cargando_spinner = false;
    if (this.isValid) {
      window.open(this.link, '_blank');
    } else {
      this.router.navigate([this.link], { queryParams: query_params });
    } 
  }

  private mapBenefitToComponent(params: any, categories: any[], beneficiaryTypes: any[], planes: any[]) {
    const benefit = this.getBenefit(params);
    if (!benefit) return;

    this.id = benefit.id;
    this.title = benefit.title;
    this.description = benefit.description;
    this.longDescription = benefit.longDescription;
    this.totalVotes = benefit.totalStars;
    this.average = benefit.average;
    this.planId = benefit.plans;
    this.plan = this.imagenPlan(planes, benefit);
    this.isCopec = benefit.isCopec;
    this.vigencia = this.resolveVigencia(benefit);

    const matchCategory = categories.find((c: any) => c.id === benefit.categories[0]);
    this.category = matchCategory.description;
    this.icon = matchCategory.icon;
    this.link = benefit.link;
    this.image = benefit.image;
    this.antiquity = benefit.antiques[0];
    this.beneficiaryType = this.resolveBeneficiaryType(benefit, beneficiaryTypes);
    this.resolveHyperLink(benefit);
  }

  private resolveVigencia(benefit: any): boolean {
    if (benefit.vigencia !== undefined && benefit.vigencia !== null) {
      return benefit.vigencia;
    }
    if (benefit.statusbt) {
      const estadoId = benefit.statusbt.id;
      // 3 = Publicado → vigencia false (activo y visible)
      // 1 = Oculto → vigencia false (activo pero oculto)
      // Cualquier otro caso → vigencia true (Deshabilitado/No vigente)
      return !(estadoId === 3 || estadoId === 1);
    }
    return true;
  }

  private resolveBeneficiaryType(benefit: any, beneficiaryTypes: any[]): string {
    if (benefit.beneficiaryTypes.length === beneficiaryTypes.length) {
      return 'Todos';
    }
    return beneficiaryTypes
      .filter((item: any) => benefit.beneficiaryTypes.includes(item.id))
      .map((item: any) => item.description)
      .join(', ');
  }

  private resolveHyperLink(benefit: any) {
    if (benefit.link !== '') {
      this.showHyperLink = true;
    } else if (this.id === BENEFICIO_ID.BONO_VACACIONES) {
      this.title = 'Bono Vacaciones';
      this.link = '/form/holiday-bonus';
      this.showHyperLink = true;
    }
  }

  getBenefit(params: any) {
    const benefits = JSON.parse(
      this.commonService.getItemLocalStorage('benefits') ?? '[]',
    );
    return benefits.length === 0
      ? undefined
      : benefits.find((b: any) => b.id === parseInt(params.idBenefit));
  }

  averageUpdate() {
    if (this.datorating != 0) {
      const setSuma = this.average * this.totalVotes + this.datorating;
      const newtotalvoters = this.totalVotes + 1;
      return (setSuma / newtotalvoters);
    } else {
      return this.average;
    }
  }

  benefitIsPlan() {
    if (this.planId.includes(this.user_plan.plan_id)) {
      return true;
    } else {
      return false;
    }
  }

  antiguedadRequerida(){
    if(this.antiquity === 1){
      return`${this.antiquity} año`
    }
    if(this.antiquity > 1){
        return`${this.antiquity} años`
    }else{
      return'Sin antigüedad'
    }   
  }

  async verificarBonosVacaciones() {
    try {
      const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
      if (!employeeSap || !employeeSap.colaborador) {
        console.error('No se pudo obtener datos del colaborador');
        this.navegarAFormulario();
        return;
      }

      const validacionBonos = await this.validarDisponibilidadBonos(employeeSap);
      if (!validacionBonos) return;

      const validacionContrato = await this.validarContratoYAntiguedad(employeeSap);
      if (!validacionContrato) return;

      const validacionSolicitudPrevia = await this.validarSolicitudPreviaBonoMesActual(employeeSap.colaborador.rut);
      if (!validacionSolicitudPrevia) return;

      this.navegarAFormulario();
    } catch (error) {
      console.error('Error al verificar bonos de vacaciones:', error);
      this.navegarAFormulario();
    }
  }

  private async validarDisponibilidadBonos(employeeSap: any): Promise<boolean> {
    const idColaborador = employeeSap.colaborador.idColaborador;
    if (!idColaborador) {
      console.error('No se pudo obtener el idColaborador');
      this.navegarAFormulario();
      return false;
    }

    const response = await this.solicitudVacacionesService.validarBonosDisponibles(Number(idColaborador));

    if (response?.success && response?.data?.resumen) {
      const totalBonosGanados = parseInt(response.data.resumen.total_bonos_ganados ?? '0', 10) || 0;
      const bonosDisponibles = Math.floor(totalBonosGanados / 10);

      if (bonosDisponibles < 1) {
        this.mostrarAlerta('Sin Bonos Disponibles', 'No posees bonos disponibles para solicitar este beneficio.');
        return false;
      }
      return true;
    }

    this.navegarAFormulario();
    return false;
  }

  private async validarContratoYAntiguedad(employeeSap: any): Promise<boolean> {
    const hoy = new Date();
    const fechaHoy = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
    const idColaboradorGH = employeeSap.colaborador.idColaborador;
    
    try {
      // Fecha de inicio fija para obtener historial completo desde 1990
      const gestionHumanaResp = await this.gestionHumanaService.getGestionHumana(idColaboradorGH, '1990-01-01', fechaHoy);
      
      const contratoData = Array.isArray(gestionHumanaResp) && gestionHumanaResp.length > 0
        ? gestionHumanaResp[0]?.contrato
        : null;

      if (contratoData && contratoData.length > 0) {
        // Ordenar contratos por fecha de inicio descendente (más reciente primero)
        const contratosOrdenados = [...contratoData].sort((a, b) => {
          const fechaA = new Date(a.fecha?.inicio || '1900-01-01');
          const fechaB = new Date(b.fecha?.inicio || '1900-01-01');
          return fechaB.getTime() - fechaA.getTime();
        });

        const contratoActual = contratosOrdenados[0];

        // Validar que el contrato actual sea Indefinido
        if (contratoActual.duracion !== 'Indefinido') {
          this.mostrarAlerta('Contrato No Válido', 'El colaborador no cuenta con un contrato indefinido para postular a este beneficio.');
          return false;
        }

        // Calcular meses del contrato actual
        const mesesContratoActual = this.calcularMesesTrabajados(new Date(contratoActual.fecha?.inicio), hoy);

        // Si el contrato actual tiene >= 12 meses, aprobar directamente
        if (mesesContratoActual >= 12) {
          return true;
        }

        // Si tiene < 12 meses, sumar contratos continuos hacia atrás
        const mesesTotales = this.calcularMesesContratosContinuos(contratosOrdenados, hoy);

        if (mesesTotales < 12) {
          this.mostrarAlerta(
            'Antigüedad Insuficiente', 
            `El colaborador tiene ${mesesTotales} meses de antigüedad continua y requiere al menos 12 meses para postular al beneficio.`
          );
          return false;
        }

        return true;
      }
    } catch (errorGH) {
      console.error('Error al verificar contrato de gestión humana:', errorGH);
    }
    
    return true;
  }

  private calcularMesesContratosContinuos(contratos: any[], fechaActual: Date): number {
    if (contratos.length === 0) return 0;

    let mesesTotales = 0;
    let fechaFinAnterior: Date | null = null;

    // Iterar contratos desde el más reciente
    for (let i = 0; i < contratos.length; i++) {
      const contrato = contratos[i];
      const fechaInicio = new Date(contrato.fecha?.inicio);
      const fechaFin = contrato.fecha?.fin === '9999-12-31' 
        ? fechaActual 
        : new Date(contrato.fecha?.fin);

      // Para el primer contrato (más reciente)
      if (i === 0) {
        mesesTotales = this.calcularMesesTrabajados(fechaInicio, fechaActual);
        fechaFinAnterior = new Date(contrato.fecha?.inicio);
        continue;
      }

      // Verificar si el contrato es continuo con el anterior
      const esContinuo = this.sonContratosContinuos(fechaFin, fechaFinAnterior);
      
      if (!esContinuo) {
        break;
      }

      // Sumar meses de este contrato
      const mesesContrato = this.calcularMesesTrabajados(fechaInicio, fechaFin);
      mesesTotales += mesesContrato;
      fechaFinAnterior = fechaFin;
    }

    return mesesTotales;
  }

  private sonContratosContinuos(fechaFinContrato: Date, fechaInicioSiguiente: Date | null): boolean {
    if (!fechaInicioSiguiente) return false;

    // Calcular el día siguiente a la fecha de fin
    const diaSiguiente = new Date(fechaFinContrato);
    diaSiguiente.setDate(diaSiguiente.getDate() + 1);

    // Comparar solo año, mes y día (ignorar hora)
    const esContinuo = 
      diaSiguiente.getFullYear() === fechaInicioSiguiente.getFullYear() &&
      diaSiguiente.getMonth() === fechaInicioSiguiente.getMonth() &&
      diaSiguiente.getDate() === fechaInicioSiguiente.getDate();

    return esContinuo;
  }

  private async validarSolicitudPreviaBonoMesActual(rut: string): Promise<boolean> {
    const respuestaConsulta = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
      BENEFICIO_ID.BONO_VACACIONES,
      rut,
      ESTADO_SOLICITUD.APROBADA
    );

    if (respuestaConsulta?.existe && respuestaConsulta.total > 0) {
      const hoy = new Date();
      const tieneBonoEsteMes = this.verificarSolicitudEnMesActual(respuestaConsulta.solicitudes, hoy);

      if (tieneBonoEsteMes) {
        this.mostrarAlerta('Bono en Curso', 'El colaborador ya tiene un bono en curso para este mes.');
        return false;
      }
    }

    return true;
  }

  private calcularMesesTrabajados(fechaInicio: Date, fechaActual: Date): number {
    return (fechaActual.getFullYear() - fechaInicio.getFullYear()) * 12
      + (fechaActual.getMonth() - fechaInicio.getMonth());
  }

  private verificarSolicitudEnMesActual(solicitudes: any[], fecha: Date): boolean {
    const mesActual = fecha.getMonth();
    const anioActual = fecha.getFullYear();

    return solicitudes.some((s: any) => {
      if (!s?.fecha_creacion) return false;
      const fechaSolicitud = new Date(s.fecha_creacion);
      return fechaSolicitud.getMonth() === mesActual && fechaSolicitud.getFullYear() === anioActual;
    });
  }

  private mostrarAlerta(titulo: string, mensaje: string) {
    this.tituloAlertaCuotas = titulo;
    this.mensajeAlertaCuotas = mensaje;
    this.permitirContinuar = false;
    this.modalAlertaCuotas = true;
    this.cargando_spinner = false;
  }

  /**
   * Obtiene y valida los datos del colaborador
   */
  private async obtenerDatosColaborador(): Promise<{ rut: string; nombre: string } | null> {
    const employeeSap = await this.employeeSapService.getEmployeeSapByRut();
    
    if (!employeeSap?.colaborador?.rut) {
      console.error('No se pudo obtener el RUT del colaborador');
      return null;
    }

    return {
      rut: employeeSap.colaborador.rut,
      nombre: `${employeeSap.colaborador.nombres} ${employeeSap.colaborador.apellidoPaterno}`
    };
  }

  /**
   * Recopila el ID de solicitud y el nombre completo de los beneficiarios asociados
   */
  private recopilarIdsSolicitudes(respuesta: any): { solicitud_id: number; beneficiarios: string[] }[] {
    if (!respuesta?.existe || respuesta.total === 0 || !respuesta.solicitudes?.length) {
      return [];
    }

    return respuesta.solicitudes
      .filter((solicitud: any) => solicitud.solicitud_id)
      .map((solicitud: any) => ({
        solicitud_id: solicitud.solicitud_id,
        beneficiarios: this.extraerBeneficiarios(solicitud)
      }));
  }

  /**
   * Extrae el nombre completo de los beneficiarios desde una solicitud
   */
  private extraerBeneficiarios(solicitud: any): string[] {
    const beneficiarios = solicitud?.formulario?.beneficiarios ?? [];

    return beneficiarios
      .map((beneficiario: any) => {
        const nombre = beneficiario?.Nombres?.valor ?? '';
        const apellidoPaterno = beneficiario?.Apellido_Paterno?.valor ?? '';
        return ` ${nombre} ${apellidoPaterno}`.trim();
      })
      .filter((nombreCompleto: string) => Boolean(nombreCompleto));
  }

  /**
   * Muestra modal con las solicitudes en proceso
   */
  private mostrarModalSolicitudesEnProceso(ids: { solicitud_id: number; beneficiarios: string[] }[]) {
    this.solicitudesEnProcesoIds = ids;
    this.tituloSolicitudesEnProceso = 'Solicitudes en Proceso';
    this.mensajeSolicitudesEnProceso = `El colaborador ${this.nombreColaborador} tiene solicitudes en proceso con los siguientes datos:`;
    this.modalSolicitudesEnProceso = true;
    this.cargando_spinner = false;
  }

  /**
   * Guarda solicitudes en localStorage
   */
  private guardarSolicitudesEnLocalStorage(respuesta86: any, respuesta100: any) {
    const todasLasSolicitudes = [
      ...(respuesta86?.solicitudes || []),
      ...(respuesta100?.solicitudes || [])
    ];
    
    this.commonService.setItemLocalStorage('solicitudes_beneficio_en_proceso', JSON.stringify(todasLasSolicitudes));
  }

  /**
   * Verifica si el colaborador tiene solicitudes en proceso para el beneficio 86 y 100
   * Antes de permitir crear una nueva solicitud de Incorporación Beneficiario
   */
  async verificarSolicitudesIncorporacionBeneficiario() {
    try {
      const datosColaborador = await this.obtenerDatosColaborador();
      
      if (!datosColaborador) {
        this.navegarAFormulario();
        return;
      }

      this.nombreColaborador = datosColaborador.nombre;

      // Consultar solicitudes del beneficio 86
      const respuesta86 = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.INCORPORACION_BENEFICIARIO,
        datosColaborador.rut,
        ESTADO_SOLICITUD.PENDIENTE
      );

      // Consultar solicitudes del beneficio 100
      const respuesta100 = await this.consultaSolicitudService.consultarSolicitudPorBeneficio(
        BENEFICIO_ID.SEGURO_COMPLEMENTARIO_ADICIONAL,
        datosColaborador.rut,
        ESTADO_SOLICITUD.PENDIENTE
      );

      // Recopilar todos los IDs
      const ids86 = this.recopilarIdsSolicitudes(respuesta86);
      const ids100 = this.recopilarIdsSolicitudes(respuesta100);
      const solicitudesIds = [...ids86, ...ids100] as { solicitud_id: number; beneficiarios: string[] }[];

      // Guardar solicitudes en localStorage
      this.guardarSolicitudesEnLocalStorage(respuesta86, respuesta100);

      // Mostrar modal o continuar según corresponda
      if (solicitudesIds.length > 0) {
        this.mostrarModalSolicitudesEnProceso(solicitudesIds);
        return;
      }

      this.navegarAFormulario();

    } catch (error) {
      console.error('Error al verificar solicitudes de incorporación de beneficiario:', error);
      this.navegarAFormulario();
    }
  }

  /**
   * Cierra el modal de solicitudes en proceso y continúa con el flujo normal
   */
  continuarConFormulario() {
    this.modalSolicitudesEnProceso = false;
    this.navegarAFormulario();
  }

  /**
   * Cierra el modal y navega a la página de mis solicitudes
   */
  irAMisSolicitudes() {
    this.modalSolicitudesEnProceso = false;
    this.router.navigate(['/my-requests']);
  }

  /**
   * Cierra el modal de solicitudes en proceso sin hacer nada
   */
  closeModalSolicitudesEnProceso() {
    this.modalSolicitudesEnProceso = false;
  }

  /**
   * Navega al detalle de una solicitud específica
   * @param solicitudId - ID de la solicitud a visualizar
   */
  irADetalleSolicitud(solicitudId: number) {
    this.modalSolicitudesEnProceso = false;
    this.router.navigate(['/form/request-detail', solicitudId]);
  }



}
